<template>
    <div class="page-video" v-if="video">
        <!-- <iframe :src="`https://www.youtube.com/embed/${video.videoId.params.v}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" class="card-video__iframe"></iframe> -->
        <youtube :video-id="video.videoId.params.v" ref="youtube" @playing="play" @paused="paused" @ended="ended" />
        <LeadsColector v-if="isBr"></LeadsColector>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-9">
                    <div class="page-video__header">
                        <div class='page-video__share-icons'>
                            <ShareIcons :text="$root.t('Mantenha%20sua%20rotina%20de%20treinos%20com%20%23TreineEmCasa%20da%20@SmartFitoficial%20Acesse:')" ></ShareIcons>
                        </div>
                        <h1 class="page-title" v-html="$root.getTitle(video)"></h1>
                        <h4 @click="$root.returnToPreviousPage()" class="page-video__workout">{{ activeWorkout.title }}</h4>
                        <div class="page-video__description" v-html="video.description"></div>

                        <a href="javascript:void(0);" class="btn btn-outline" @click="$root.returnToPreviousPage()" >{{ $root.t('Voltar') }}</a>
                    </div>
                </div>

                <div class="col-md-3 mt-5" v-if="videoKits.length">
                    <div class="page-video__kits">
                        <KitCard v-for="kit in videoKits" :key="kit.ID" :kit="kit" :category="kit.categories[0].slug"></KitCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import KitCard from '@/components/KitCard'
import ShareIcons from '@/components/ShareIcons'
import LeadsColector from '@/components/LeadsColector'

export default {
    components : { KitCard, ShareIcons, LeadsColector },
    data () {
        return {
            workoutId : this.$route.params.id,
            videoId :  this.$route.params.video,
            video : false,
            videoKits : [],
            videoDuration : 0,
            currentTime : 0,
            intervalId : false,
            gaStatus : 'unstarted',
            isBr : window.location.host.indexOf('.br') !== -1
        }
    },
    computed : {
        ...mapGetters([
            'activeWorkout',
            'workouts',
            'kits',
            'theme'
        ]),
        player() {
            return this.$refs.youtube.player
        }
    },
    watch : {
        workouts () {
            this.setActiveWorkout(this.workoutId)
        },
        activeWorkout() {
            if(this.activeWorkout) {
                this.setActiveVideo()
            }
        },
        kits () {
            if( this.video.kits ) {
                this.videoKits = this.video.kits.map( kit => {
                    if(!kit.categories.length) {
                        return false
                    }
                    let filtered_kit = {};

                    for (let i = 0; i < this.kits[kit.categories[0].slug].kits.length; i++ ) {
                        if ( this.kits[kit.categories[0].slug].kits[i].ID == kit.ID ) {
                            filtered_kit = this.kits[kit.categories[0].slug].kits[i];
                        }
                    }

                    return filtered_kit
                })
            }
        }
    },
    methods : {
        ...mapActions({
            setActiveWorkout : 'setActiveWorkout',
            getKits : 'getKits',
        }),
        setActiveVideo() {
            this.video = this.activeWorkout.videos.find ( v => v.slug == this.videoId )
            this.getKits()
        },
        async play() {
            this.videoDuration = await this.player.getDuration()
            this.playing()
            this.gaEvent('Start')
        },
        async paused() {
            this.gaEvent('Pause')
            clearInterval(this.intervalId)
        },
        ended () {
            this.gaEvent('Complete')
            clearInterval(this.intervalId)
        },
        playing(){
            this.intervalId = setInterval( async() => {
                this.currentTime = await this.player.getCurrentTime()
                let percentage = this.currentTime * 100 / this.videoDuration;

                if( Math.floor(percentage) >= 25 && Math.floor(percentage) < 50 && this.gaStatus != '25%' ) {
                    this.gaEvent('25%')
                } else if ( Math.floor(percentage) == 50 && Math.floor(percentage) < 75 && this.gaStatus != '50%' ) {
                    this.gaEvent('50%')
                } else if ( Math.floor(percentage) == 75 && this.gaStatus != '75%' ) {
                    this.gaEvent('75%')
                }
            }, 1000 )
        },
        gaEvent(event) {

            this.gaStatus = event;
            this.$gtm.trackEvent({
                event : 'gaEvent',
                eventCategory : 'Youtube',
                eventAction : `Treine em Casa: ${this.activeWorkout.title} - ${this.video.title.replace('&#8211;', '')} - ${event}`,
                eventLabel : `${this.workoutId} - ${this.activeWorkout.title}`,
                value : ''
            });
        }
    },
    created () {

        if (!this.activeWorkout) {
            this.setActiveWorkout(this.workoutId)
        } else {
            this.setActiveVideo()
        }
    },
    destroyed() {
        clearInterval(this.intervalId)
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/settings/_variables.scss";
    @import "@/assets/scss/settings/_mixins.scss";

    .page-video {
        /deep/ iframe {
            display: block;
            margin: 0 auto;
            width: 100vw;
            height: calc( 100vw / 1.77);

            @include desktop {
                width: 70vw;
                height: calc( 70vw / 1.77);
            }
        }

        &__header {
            padding: 40px 20px;
            text-align: center;
        }

        &__workout {
            color: $c_primary;
            font-size: 18px;
            font-weight: 300;
            cursor: pointer;
        }

        &__description {
            font-size: 18px;
            opacity: 0.8;
            margin-bottom: 15px;
        }

        &__share-icons {
            padding: 0 0 20px;
        }
    }
</style>
